import styled from '@emotion/styled';
import { Typography, Modal } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

type Theme = {
  theme?: ICustomTheme;
};

export const Condition = styled(Typography)<Theme>(({ theme }) => ({
  lineHeight: theme.typography.h4.lineHeight,
  marginBottom: theme.spacing(2),
  textAlign: 'left',
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(1),
  },
}));

export const Container = styled.div<Theme>(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  border: 'none',
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[5],
  boxSizing: 'border-box',
  color: theme.colors.grey.dark,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  maxWidth: '75%',
  padding: theme.spacing(10),
  textAlign: 'center',
  ':focus': {
    outline: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    maxWidth: '90%',
    padding: theme.spacing(2, 3),
  },
}));

export const StyledModal = styled(Modal)(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
}));

export const Subtitle = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

export const Title = styled(Typography)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  marginBottom: theme.spacing(3),
  paddingLeft: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    marginBottom: theme.spacing(2),
    paddingLeft: 0,
  },
}));
